import { render, staticRenderFns } from "./SessionWinner.vue?vue&type=template&id=732b77d8&"
import script from "./SessionWinner.vue?vue&type=script&lang=js&"
export * from "./SessionWinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports